export function switchyardHref(contextUUID) {
    return `/teammate/${encodeURIComponent(contextUUID)}`;
}
//# sourceMappingURL=switchyardRoutes.js.map